import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { BoardManager } from "./BoardManager";
import { AudioManager } from "../../AudioManager";
import { BoardState } from "./BoardState";

// TODO: https://gyazo.com/2c42959126ba1782756cf33282d11ee0
export class Cell extends Phaser.Group {

    public opened: boolean;

    private isDown: boolean;
    private isRightMouseDown: boolean;
    private cellBack: Phaser.Image;
    private flagIcon: Phaser.Image;
    private debugMineIcon: Phaser.Image;
    private destroyCellFrontOnNextFrame: boolean;
    private cellFront: Phaser.Image;
    private f: number;
    private framesToAppear: number;
    private hasNotAppeared: boolean;
    private pos: {r: number, c: number};
    private cellBackFrame: string;
    private timeDown: number;
    private discardOnUp: boolean;

    constructor(game: Phaser.Game, p: { r: number, c: number }) {

        super(game, null, "cell");

        this.pos = p;
        this.f = 0;
        this.framesToAppear = 15 + Math.floor(p.r / GameVars.boardSize.r * 45);
        this.hasNotAppeared = true;
        this.timeDown = 0;

        this.x = (this.pos.c - GameVars.boardSize.c * .5) * GameConstants.CELL_SIZE;
        this.y = (this.pos.r - GameVars.boardSize.r * .5) * GameConstants.CELL_SIZE;

        this.opened = false;
        this.isDown = false;
        this.destroyCellFrontOnNextFrame = false;
        this.debugMineIcon = null;
        this.cellBackFrame = "cell_01";
        this.discardOnUp = false;

        this.cellBack = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "cell_01");
        this.cellBack.visible = false;
        this.cellBack.anchor.set(.5);
        this.add(this.cellBack);

        this.cellFront = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "cell_02");
        this.cellFront.alpha = 0;
        this.cellFront.scale.set(.6);
        this.cellFront.inputEnabled = true;
        this.cellFront.events.onInputUp.add(this.onUp, this);
        this.cellFront.events.onInputDown.add(this.onDownCellFront, this);
        this.cellFront.events.onInputOver.add(() => {
            this.cellFront.scale.set(1.04);
        }, this);
        this.cellFront.events.onInputOut.add(() => {
            this.cellFront.scale.set(1);
        }, this);
        this.cellFront.anchor.set(.5);
        this.add(this.cellFront);

        this.flagIcon = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "cell_11");
        this.flagIcon.visible = false;
        this.flagIcon.anchor.set(.5);
        this.add(this.flagIcon);

        if (this.game.device.desktop) {
            this.isRightMouseDown = false;
        }
    }

    public update(): void {

        if (GameVars.paused) {
            return;
        }

        if (this.hasNotAppeared && this.cellFront) {

            this.f ++;

            if (this.f > this.framesToAppear) {

                this.cellFront.alpha += .075;
                this.cellFront.scale.x += .025;
                this.cellFront.scale.y += .025;

                if (this.cellFront.alpha >= 1) {
                    this.cellFront.alpha = 1;
                    this.hasNotAppeared = false;
                }

                if (this.cellFront.scale.x >= .95) {
                    this.cellFront.scale.x = 1;
                    this.cellFront.scale.y = 1;
                }
            }
        }

        if (this.isDown && !this.isRightMouseDown) {

            let cell = this.flagIcon.visible ? this.flagIcon : this.cellFront;

            if (cell) {
                cell.alpha -= this.game.time.physicsElapsed * 2;

                if (cell.alpha < .35) {
                    cell.alpha = .35;
                }
    
                const dt = this.game.time.time - this.timeDown;
    
                if (dt > 250) {
                    this.onUp();
                    this.discardOnUp = true;
                }
            }
        }

        if (this.destroyCellFrontOnNextFrame) {
            this.destroyCellFrontOnNextFrame = false;
            this.cellFront.destroy();
            this.cellFront = null;
        }
    }

    public start(): void {

        if (GameVars.grid[this.pos.r][this.pos.c].numAdjacentMines !== 0) {

            switch (GameVars.grid[this.pos.r][this.pos.c].numAdjacentMines) {
                case 1:
                    this.cellBackFrame = "cell_03";
                    break;
                case 2:
                    this.cellBackFrame = "cell_04";
                    break;
                case 3:
                    this.cellBackFrame = "cell_05";
                    break;
                case 4:
                    this.cellBackFrame = "cell_06";
                    break;
                case 5:
                    this.cellBackFrame = "cell_07";
                    break;
                case 6:
                    this.cellBackFrame = "cell_08";
                    break;
                case 7:
                    this.cellBackFrame = "cell_09";
                    break;
                case 8:
                    this.cellBackFrame = "cell_10";
                    break;
                default:
                    break;
            }

            this.cellBack.frameName = this.cellBackFrame;

            this.cellBack.inputEnabled = true;
            this.cellBack.events.onInputDown.add(this.onDownCellBack, this);
            this.cellBack.events.onInputUp.add(this.onUpCellBack, this);
        }

        if (GameVars.grid[this.pos.r][this.pos.c].isMine) {
            this.cellBackFrame = "cell_12";
        }

        if (this.cellBackFrame) {
            this.cellBack.frameName = this.cellBackFrame;
        }

        if (GameConstants.DEBUG_MODE) {
            this.showDebugItems();
        }
    }

    public flag(): void {

        this.flagIcon.visible = true;
        this.flagIcon.alpha = 1;
        this.cellFront.alpha = 0;

        this.flagIcon.scale.set(.65);
        this.game.add.tween(this.flagIcon.scale)
            .to ({x: 1, y: 1}, 150, Phaser.Easing.Cubic.Out, true);

        AudioManager.playSound("flagged_cell");
    }

    public unFlag(): void {

        if (!this.flagIcon.visible) {
            return;
        }

        if (GameVars.matchOver) {

            if (GameVars.grid[this.pos.r][this.pos.c].isMine) {
                this.flagIcon.frameName = "cell_12";
            } else {
                this.flagIcon.frameName = "cell_flagged_wrong";
            }
            
        } else {

            this.flagIcon.visible = false;

            if (this.cellFront !== null) {
                this.cellFront.alpha = 1;
            }
        }
    }

    public open(): void {

        this.opened = true;

        this.destroyCellFrontOnNextFrame = true;

        this.cellBack.visible = true;
        this.cellBack.frameName = this.cellBackFrame;

        if (GameConstants.DEBUG_MODE) {

            if (this.debugMineIcon) {
                this.debugMineIcon.destroy();
            }
        }
    }

    public explode(): void {

        const explosion = <Phaser.Sprite> this.create(0, -this.cellBack.width / 2, "texture_atlas_1", "splash_bomb_00");
        explosion.anchor.set(.5);
        explosion.animations.add("explode", Phaser.Animation.generateFrameNames("splash_bomb_", 0, 35, "", 2));
        explosion.animations.play("explode", 26, false, true);
        
        this.game.camera.shake(.0125, 150);

        AudioManager.playSound("explosion");
    }

    public check(): void {

        this.cellFront.visible = false;

        if (this.cellBack) {
            this.cellBack.visible = true;
            this.cellBack.frameName = "cell_01";
        }
    }

    public uncheck(): void {
        
        this.cellFront.visible = true;
        this.cellBack.visible = false;

        if (this.cellBack) {
            this.cellBack.frameName = this.cellBackFrame;
        }
    }

    private showDebugItems(): void {

        if (GameVars.grid[this.pos.r][this.pos.c].isMine) {
            this.debugMineIcon = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "mine");
            this.debugMineIcon.anchor.set(.5);
            this.add(this.debugMineIcon);
        }
    }

    private onDownCellFront(onDown: any, p: Phaser.Pointer) {

        if (GameVars.paused) {
            return;
        }

        this.isDown = true;
        this.timeDown = this.game.time.time;
        this.discardOnUp = false;

        if (this.game.device.desktop) {
            if (p.rightButton.isDown) {
                this.isRightMouseDown = true;
            }
        }

        if (!this.flagIcon.visible) {
            BoardState.currentInstance.gui.onDownCell();
        }
    }

    private onUp(cell?: Cell, pointer?: Phaser.Pointer): void {

        if (GameVars.paused || this.hasNotAppeared || this.discardOnUp) {
            return;
        }

        this.isDown = false;

        if (this.flagIcon.visible) {
            this.flagIcon.alpha = 1;
        }

        if (!this.flagIcon.visible) {
            BoardState.currentInstance.gui.onUpCell();
        }

        if (this.isRightMouseDown) {
            this.isRightMouseDown = false;
        }

        if (pointer) {
            BoardManager.onCellUp(this.pos, pointer.timeUp - pointer.timeDown, this.isRightMouseDown);
        } else {
            BoardManager.onCellUp(this.pos, 1e3, this.isRightMouseDown);
        }  
    }

    private onDownCellBack(): void {

        if (this.cellFront === null) {
            BoardManager.checkSurroundingCells(this.pos);
        }
    }

    private onUpCellBack(p: any, b: any): void {

        const dt = b.timeUp - b.timeDown;

        if (this.cellFront === null) {
            BoardManager.uncheckSurroundingCells(this.pos, dt);
        }
    }
}
